//菜单主题类型
export enum ThemeEnum {
    LIGHT = 'light',
    DARK = 'dark'
}

// 菜单类型
export enum MenuEnum {
    CATALOGUE = 'M',
    MENU = 'C',
    BUTTON = 'A'
}

// 屏幕
export enum ScreenEnum {
    SM = 640,
    MD = 768,
    LG = 1024,
    XL = 1280,
    '2XL' = 1536
}

// 客户端类型
export enum ClientEnum {
    MP_WEIXIN = 1, // 微信-小程序
    OA_WEIXIN = 2, // 微信-公众号
    H5 = 3, // H5
    PC = 4, // PC
    IOS = 5, //苹果
    ANDROID = 6 //安卓
}

export const ClientMap = {
    [ClientEnum.MP_WEIXIN]: '微信小程序',
    [ClientEnum.OA_WEIXIN]: '微信公众号',
    [ClientEnum.H5]: '手机H5',
    [ClientEnum.PC]: '电脑PC',
    [ClientEnum.IOS]: '苹果APP',
    [ClientEnum.ANDROID]: '安卓APP'
}

// 备案配置信息
export enum RecordsConfigEnum {
    //通讯设置-ICP/IP通讯参数设置
    ISPAPI = 'isp_api',
    //通讯设置-SFTP本地全量上报接口配置
    SFTP = 'sftp',
    //企业设置
    COMPANY = 'company',
    //邮件服务器
    SMTP = 'smtp',
    //第三方接口-备案数据交互API
    INTERACTIVE = 'interactive',
    //第三方接口-云拓真实性核验接口参数配置
    YUNTUO = 'yuntuo',
    //第三方接口-百度云接口参数设置
    BAIDU = 'baidu',
    //第三方接口-国证通接口参数设置
    GUOZHENGTONG = 'guozhengtong',
    //第三方接口-短信接口参数设置
    MESSAGE = 'message',
    //备案设置
    FILINGS = 'filings',
    //系统设置
    SYSTEM = 'system',
    //电子核验设置-小程序参数配置
    APPLET = 'applet',
    //电子核验设置-电子核验功能设置
    VERIFICATION = 'verification',
    //ICP监管设置-ICP备案监管通讯参数设置
    ICP_SUPERVISE = 'icp_supervise',
    //工信部核验设置-工信部电子核验平台参数设置,
    GXBCHECKPARAM = 'gxb_check_param',
    // 阿里云SDK配置
    ALIYUNSDK = 'aliyun_sdk',
    // 聚美SDK配置
    LIVE_DETECTION_JM = 'live_detection_jm',
    // 解析key
    WEBPARSE = 'web_parse',
    // 云市场SDK配置
    CLOUDMARKET = 'cloud_market',
    // 更新相关
    SOFTWAREUPDATE = 'software_update'
}

// 表单尺寸
export enum FormSize {
    SMALL = 'small',
    Default = 'default',
    LARGE = 'large'
}

// 提交图片类型
export enum SubmitImageType {
    // 身份证
    IDCARD = 1,
    // 其他个人证件(护照等)
    PERSONALDOCUMENTATION = 2,
    // 营业执照
    SPONSORCERT = 3,
    // 其他单位证件(事业单位法人证书等)
    UNITCERTIFICATE = 4,
    // 其他证件(备案承诺书、专项审批文件等)
    OTHERDOCUMENTS = 5,
    // 活体核验
    LIVEEXAMINATION = 6,
    // 承诺书单位
    UNITLETTERCOMMITMENT = 7,
    // 承诺书个人
    PERSONAGELETTERCOMMITMENT = 8,
    // 单位核验单
    UNITVERIFICATIONFORM = 9,
    // 个人核验单
    PERSONAGEVERIFICATIONFORM = 10,
    // IP申诉证明材料
    EVIDENTIARYMATERIAL = 11,
    // APP图标
    APPICON = 12
}
